import { CaseActions, OrderActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { CaseFormData } from 'src/screens/General/screens/Cases/components/CaseForm';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';
import { GetStudentsSmallAction } from './student-actions';

export interface GetCasesAction {
    type: typeof CaseActions.FETCH_CASES;
    payload: QueryParams;
}

export function getCases(params: QueryParams): GetCasesAction {
    return {
        type: CaseActions.FETCH_CASES,
        payload: params,
    };
}

export interface GetCasesSmallAction {
    type: typeof CaseActions.FETCH_CASES_SIMPLY;
    payload: QueryParams;
}

export function getCasesSmall(params: QueryParams): GetCasesSmallAction {
    return {
        type: CaseActions.FETCH_CASES_SIMPLY,
        payload: params,
    };
}

export interface GetStatementsDocsAction {
    type: typeof CaseActions.FETCH_STATEMENT_DOCS;
    payload: QueryParams;
}

export function getStatementsDocs(params: QueryParams): GetStatementsDocsAction {
    return {
        type: CaseActions.FETCH_STATEMENT_DOCS,
        payload: params,
    };
}

export interface CreateStatementAction {
    type: typeof CaseActions.CREATE_STATEMENT;
    payload: {
        data: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createStatement(
    data: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateStatementAction {
    return {
        type: CaseActions.CREATE_STATEMENT,
        payload: { data, onSuccess, onError },
    };
}

export interface CaseNumbersAction {
    type: string;
    payload: AnyObject;
}

export function caseNumbers(): CaseNumbersAction {
    return {
        type: CaseActions.CASE_NUMBERS,
        payload: {},
    };
}

export interface CaseNumbersStudentAction {
    type: string;
    payload: any;
}

export function caseNumbersStudent(params: any): CaseNumbersStudentAction {
    return {
        type: CaseActions.CASE_NUMBERS_STUDENT,
        payload: params,
    };
}

export interface GetCasesAnotherAction {
    type: typeof CaseActions.FETCH_CASES_ANOTHER;
    payload: QueryParams;
}

export function getCasesAnother(params: QueryParams): GetCasesAnotherAction {
    return {
        type: CaseActions.FETCH_CASES_ANOTHER,
        payload: params,
    };
}

export interface GetCaseAction {
    type: typeof CaseActions.FETCH_CASE;
    payload: {
        id: string | number;
    };
}

export function getCase(id: string | number): GetCaseAction {
    return {
        type: CaseActions.FETCH_CASE,
        payload: { id },
    };
}
export interface UpdateCaseAction {
    type: typeof CaseActions.UPDATE_CASE;
    payload: {
        data: AnyObject;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function updateCase(
    data: AnyObject,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): UpdateCaseAction {
    return {
        type: CaseActions.UPDATE_CASE,
        payload: {
            data,
            onSuccess,
            onError,
        },
    };
}
export interface DeleteCaseAction {
    type: typeof CaseActions.DELETE_CASE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteCase(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteCaseAction {
    return {
        type: CaseActions.DELETE_CASE,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistCaseAction {
    type: typeof CaseActions.PERSIST_CASE;
    payload: {
        data: CaseFormData;
        files: any;
        callbacks: SagaPromise<any>;
    };
}

export function persistCase(data: CaseFormData, files: any, callbacks: SagaPromise<any>): PersistCaseAction {
    return {
        type: CaseActions.PERSIST_CASE,
        payload: {
            data,
            files,
            callbacks,
        },
    };
}

export const asyncPersistCase = (data: CaseFormData, files: any, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistCase(data, files, { resolve, reject }));
    });
};

export interface CreateFilesCaseAction {
    type: typeof CaseActions.CREATE_FILES_CASE;
    payload: {
        id: number | string;
        files: any;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function createFilesCase(
    id: number | string,
    files: any,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): CreateFilesCaseAction {
    return {
        type: CaseActions.CREATE_FILES_CASE,
        payload: {
            id,
            files,
            onSuccess,
            onError,
        },
    };
}

export interface GetFilesAction {
    type: typeof CaseActions.FETCH_FILES_CASE;
    payload: {
        id: string | number;
    };
}

export function getFiles(id: string | number): GetFilesAction {
    return {
        type: CaseActions.FETCH_FILES_CASE,
        payload: { id },
    };
}

export interface DeleteFileCaseAction {
    type: typeof CaseActions.DELETE_FILE_CASE;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteFileCase(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteFileCaseAction {
    return {
        type: CaseActions.DELETE_FILE_CASE,
        payload: { id, onSuccess, onError },
    };
}

export interface ResetDoubleAction {
    type: string;
}

export function resetDouble(): ResetDoubleAction {
    return {
        type: 'RESET_DOUBLE',
    };
}

export interface GetCheckCasesAction {
    type: typeof CaseActions.FETCH_CHECK_CASES;
    payload: QueryParams;
}

export function getCheckCases(params: QueryParams): GetCheckCasesAction {
    return {
        type: CaseActions.FETCH_CHECK_CASES,
        payload: params,
    };
}
export type Actions =
    | CaseNumbersStudentAction
    | GetCasesAction
    | GetCasesSmallAction
    | CreateStatementAction
    | GetStatementsDocsAction
    | GetCaseAction
    | DeleteCaseAction
    | PersistCaseAction
    | UpdateCaseAction;
